import React from 'react';

import { appMethod as app } from '@utils/app';
import './ChooseLocation.less';

export class ChooseLocation extends React.Component {
  constructor(props) {
    super(props);
    this.options = this.props.options;
    // console.log(this.options);
    this.mapInstance = null;
    this.searchService = null;
    this.geocoder = null;
    this.marker = null;

    this.state = {
      locationPoi: '',
      nearPois: [],
      chooseIndex: -1,
      showSearch: false,
      searchValue: '',
      searchList: []
    };

    this.textInput = React.createRef();
  }

  componentDidMount() {
    let mapInstance = this.mapInstance = new qq.maps.Map(document.getElementById("choose-location-map") , {
      zoom: 15,
      zoomControl: false,
      panControl: false,
      mapTypeControl: false
    });

    this.getLocation();
    this.locationIcon();
    this.centerIcon();

    qq.maps.event.addListener(mapInstance, 'dragend', () => {
      this.mapLocationList(mapInstance.getCenter());
    });
  }

  // 获取定位
  getLocation(){
    app.getLocation({
      success: (res) => {
        let latlng = new qq.maps.LatLng(res.latitude, res.longitude);
        this.mapInstance.panTo(latlng);
        this.mapLocationList(latlng);
      },
      fail: (res) => {
        // 定位失败，用ip获取城市定位
        let citylocation = new qq.maps.CityService({
          complete : (result) =>{
            this.mapInstance.panTo(result.detail.latLng);
            this.mapLocationList(result.detail.latLng);
          },
          error: () => {
            // 城市定位失败，则就是默认的
            this.mapLocationList(mapInstance.getCenter());
          }
        });
        citylocation.searchLocalCity();
      }
    });
  }

  // 添加定位自定义控件
  locationIcon(){
    let locatioControl = document.createElement("div");
    locatioControl.style.cssText = 'width:35px;height:35px;border:1px solid #e9e9e9;border-radius: 20px;margin-right:10px;text-align: center;line-height: 35px;font-size: 20px;color: #07c160;background-color:#ffffff;';
    locatioControl.innerHTML = '<span class="icon-moon icon-relocate" style="line-height: 35px;"><span>';
    locatioControl.index = 3;

    this.mapInstance.controls[qq.maps.ControlPosition.RIGHT_BOTTOM].push(locatioControl);

    qq.maps.event.addListener(locatioControl, "click", () => {
      this.getLocation();
    });
  }

  // 添加中心点
  centerIcon(){
    let centerControl = document.createElement("div");
    centerControl.style.cssText = 'font-size: 20px;color: red;';
    centerControl.innerHTML = '<span class="icon-moon icon-fes_adress"><span>';
    centerControl.index = 3;

    this.mapInstance.controls[qq.maps.ControlPosition.CENTER].push(centerControl);
  }

  // 根据经纬度去设置地图中心点和拿附近的推荐点
  mapLocationList(latLng, searchAddress){
    let geocoder = new qq.maps.Geocoder({
      complete : (result) => {
          // this.marker && this.marker.setMap(null);
          // this.marker = new qq.maps.Marker({
          //     map: this.mapInstance,
          //     position: result.detail.location
          // });
          let nearPois = result.detail.nearPois;
          if(searchAddress && nearPois[0].name != searchAddress.name){
            nearPois.unshift(searchAddress);
          }
          this.setState({ 
            locationPoi: searchAddress ? '' : result.detail,
            nearPois: nearPois,
            chooseIndex: searchAddress ? 0 : -1
          });
      }
    });
    geocoder.getAddress(latLng);
  }

  // 点击事件-选择定位地址
  chooseLocationPoi(){
    this.setState({ 
      chooseIndex: -1
    });
    this.mapInstance.panTo(this.state.locationPoi.location);
  }

  // 点击事件-列表选择位置
  chooseNearPois(index){
    this.setState({ 
      chooseIndex: index
    });
    this.mapInstance.panTo(this.state.nearPois[index].latLng);
  }
  // 确定选择位置
  chooseConfirm(){
    let address = {};
    let chooseIndex = this.state.chooseIndex;
    if(chooseIndex == -1){
      let choose = this.state.locationPoi;
      address = {
        name: choose.addressComponents.streetNumber,
        address: choose.address,
        latitude: choose.location.lat,
        longitude: choose.location.lng
      };
    }else{
      let choose = this.state.nearPois[chooseIndex];
      address = {
        name: choose.name,
        address: choose.address,
        latitude: choose.latLng.lat,
        longitude: choose.latLng.lng
      };
    }
    ReactDOM.unmountComponentAtNode(document.getElementById('popup'));
    typeof this.options.success === 'function' && this.options.success(address);
  }

  // 取消选择位置
  chooseCancel(){
    ReactDOM.unmountComponentAtNode(document.getElementById('popup'));
    typeof this.options.fail === 'function' && this.options.fail();
  }

  // 去搜索
  gotoSearch(){
    this.setState({
      showSearch: true
    });
    this.textInput.current.focus();
  }

  // 取消搜索
  cencelSearch(){
    this.setState({
      showSearch: false,
      searchValue: '',
      searchList: []
    });
  }

  // 删除搜索文字
  deleteSearchText(){
    this.setState({
      searchValue: '',
      searchList: []
    });
    this.textInput.current.focus();
  }

  // 搜索输入框输入事件
  handleInputChange(e){
    let value = e.target.value;

    this.setState({
      searchValue: value
    })

    if(!this.searchService){
      this.searchService = new qq.maps.SearchService({
        complete : (results) => {
            let pois = results.detail.pois;
            console.log(results);
            if(results.type == "POI_LIST"){
              this.setState({
                searchList: pois
              })
            }
        }
      });
      this.searchService.setPageCapacity(15);
    }
    if(this.searchService){
      let region = this.state.locationPoi ? this.state.locationPoi.addressComponents.city : '深圳';
      this.searchService.setLocation(region);
      this.searchService.search(value);
    }
  }

  // 选择搜索列表
  chooseSearchPois(index){
    let address = this.state.searchList[index];

    this.mapInstance.panTo(address.latLng);
    this.mapLocationList(address.latLng, address);
    this.setState({
      showSearch: false,
      searchValue: '',
      searchList: []
    });
  }

  
  render() {
    return (
      <div className="common-api choose-location">
        <div className="choose-location-head">
          <button className="choose-location-cancel" onClick={this.chooseCancel.bind(this)}>取消</button>
          <button className="choose-location-confirm" onClick={this.chooseConfirm.bind(this)}>确定</button>
        </div>
        <div className="choose-location-search" onClick={this.gotoSearch.bind(this)}><label className="icon-moon icon-search"></label><span>搜索地点</span></div>
        <div className="choose-location-map" id="choose-location-map"></div>
        <div className="choose-location-address">
          {this.state.locationPoi && <div className="choose-address-current" onClick={this.chooseLocationPoi.bind(this)}>
            <div className="choose-address-left">
              <div className="choose-address-name">{this.state.locationPoi.address}</div>
            </div>
            <div className="choose-address-right">{this.state.chooseIndex == -1 ? <label className="icon-moon icon-gou"></label> : ''}</div>
          </div>}
          {this.state.nearPois.map((item, itemIndex) => (
            <div className="choose-address-list" key={itemIndex} onClick={this.chooseNearPois.bind(this, itemIndex)}>
              <div className="choose-address-left">
                <div className="choose-address-name">{item.name}</div>
                <div className="choose-address-address">{item.address}</div>
              </div>
              <div className="choose-address-right">{this.state.chooseIndex == itemIndex ? <label className="icon-moon icon-gou"></label> : ''}</div>
            </div>
          ))}
        </div>
        <div className="location-search-wrap" hidden={!this.state.showSearch}>
          <div className="location-search-head">
            <div className="location-search-input-wrap">
              <label className="icon-moon icon-search" htmlFor="location-search-input"></label>
              <input id="location-search-input" ref={this.textInput} type="text" placeholder="搜索地点" value={this.state.searchValue} onInput={(e) => this.handleInputChange(e)} onChange={(e) => this.handleInputChange(e)} />
              <label className="location-search-input-delete icon-moon icon-close-btn" onClick={this.deleteSearchText.bind(this)}></label> 
            </div>
            <div className="location-search-cancel" onClick={this.cencelSearch.bind(this)}>取消</div>
          </div>
          <div className="location-search-list">
            {this.state.searchList.map((item, itemIndex) => (
              <div className="search-address-list" key={itemIndex} onClick={this.chooseSearchPois.bind(this, itemIndex)}>
                <div className="search-address-name">{item.name}</div>
                <div className="search-address-address">{item.address}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/common/choose-location/ChooseLocation.jsx